module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("75OCl"))).then(() => parcelRequire('hEqeo'));